import React, { useEffect, useRef, useState } from 'react';
import { connect, Provider } from 'react-redux';
import { store } from '../../app/store';
import SchoolTile from './SchoolTile';
import '../Components/dashboard.css';
import { getSchools, getFeedback, setSchool, getSchoolTeachers, getSchoolClasses } from '../../redux';
import SchoolForm from './SchoolForm';
import FeedbackTile from './FeedbackTile';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import {useDebounce} from '../../lib/useDebounce'
import { authAxios  } from "../../lib/api";
import { useNavigate } from 'react-router-dom';

function Admin (props) {
    const navigate = useNavigate();

    const {
        getSchools,
        getFeedback,
        setSchool,
        getSchoolTeachers,
        getSchoolClasses,
        schools,
        feedback,
    } = props;

    const [message] = useState("");
    const anchorEl = useRef()
    const [showPopover, setShowPopover] = useState(false);
    const [isMakingNewSchool, setIsMakingNewSchool] = useState(false);
    const [filter, setFilter] = useState('');
    const [selectedProxyUser, setSelectedProxyUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [showInactiveSchools, setShowInactiveSchools] = useState(false);

    const selectProxyUser = (e, i, u) => {
        setSelectedProxyUser(i);
        setShowPopover(false)
    }
    const handleProxyLogin = async () => {
        const result = await authAxios.post(`/api/user/proxy`, {user: selectedProxyUser})
        if (result.data) {
            const newWindow = window.document.createElement('a')
            newWindow.href = `/login?token=${result.data.token}`
            // newWindow.target = '_blank'
            newWindow.click()
        }
    }
    
    const search = useDebounce(async (value) => {
        if (!filter || filter.length < 3) {
            setUsers([])
            return
        }
        const results = await authAxios.post('/api/user/search', { query: filter})
        if (results.data) {
            setUsers(results.data)
            setShowPopover(true)
        }
      }, 500);

    useEffect(() => {
        window.scrollTo(0, 0);
        getSchools();
        getFeedback();
    }, []);

    const setSchoolAndRedirect = (school) => {
        setSchool(school);
        getSchoolTeachers(school._id);
        getSchoolClasses(school._id);
        navigate("/school/edit");
    }

    const getMappedSchools = () => {
        return (
          schools &&
          schools
            .filter(school => school.status === "Active")
            .map((school, index) => (
            <div
              className="schoolTileContainer"
              key={index + "mapSchoolContainer"}
            >
              <SchoolTile
                key={index + "mapSchool"}
                thisSchool={school}
                handleSeeMore={() => setSchoolAndRedirect(school)}
              />
            </div>
          ))
        );
    }

    const getMappedInactiveSchools = () => {
        return (
          schools &&
          schools
            .filter(school => school.status === "Inactive")
            .map((school, index) => (
            <div
              className="schoolTileContainer"
              key={index + "mapInactiveSchoolContainer"}
            >
              <SchoolTile
                key={index + "mapInactiveSchool"}
                thisSchool={school}
                handleSeeMore={() => setSchoolAndRedirect(school)}
              />
            </div>
          ))
        );
    }

    const getMappedFeedback = () => {
        return feedback && feedback
                    .filter(feedback => !feedback.response)
                    .map((response, index) => {
                        return  <div className="tileContainer feedbackContainer" key={index + "mapResponseContainer"} >
                                    <FeedbackTile
                                        key={index + "response"}
                                        thisResponse={response}
                                    />
                                </div>
        });
    }

    const openSchoolForm = () => {
        setIsMakingNewSchool(true);
    }

    const closeSchoolForm = () => {
        setIsMakingNewSchool(false);
    }

    const onFilterChange = (e, v) => {
        setFilter(v)
        search(v)
    }

    const selectedProxy = users.find(user => user._id === selectedProxyUser)

    return (
        <div className="dashboard" style={{marginTop: "0px"}}>
            <h3 style={{marginTop: "50px"}}>Proxy Login</h3>
            <div className="proxy-login flex">
                <TextField
                    name="filter"
                    value={filter}
                    onChange={onFilterChange}
                ></TextField>
                <div className="placeholder" ref={anchorEl}></div>
                {users.length > 0 && (
                    <Popover open={showPopover} anchorEl={anchorEl.current} className="overlay-menu">
                        <Menu
                            disableAutoFocus
                            onChange={selectProxyUser}
                        >
                        {users.map((user) => (
                            <MenuItem
                            key={user._id}
                            value={user._id}
                            primaryText={`${user.firstName} ${user.lastName}- (${user.email}) — Role: (${user.type})`}
                            />
                        ))}
                        </Menu>
                    </Popover>
                )}
                {/* display selected user */}
                <FlatButton className="pinkBackground" disabled={!selectedProxyUser} onClick={handleProxyLogin}>Login as {selectedProxyUser ? `${selectedProxy.firstName} ${selectedProxy.lastName}` : ''}</FlatButton>
                
            </div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '50px'}}>
                <h3 style={{margin: '0'}}>Active Schools</h3>
                <button onClick={() => openSchoolForm()} className="actionButton">
                    Add school
                </button>
            </div>
            <div className="tiles">
                {getMappedSchools()}
            </div>
            
            {/* Visual divider */}
            <hr style={{
                margin: "60px 0 40px 0",
                border: "none",
                height: "2px",
                background: "#ccc",
            }} />
            
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '0px'}}>
                <h3 style={{margin: '0'}}>Inactive Schools</h3>
                <button 
                    onClick={() => setShowInactiveSchools(!showInactiveSchools)}
                    className="actionButton"
                    style={{marginLeft: '20px', padding: '8px 16px'}}
                >
                    {showInactiveSchools ? 'Hide' : 'Show'} Inactive Schools
                </button>
            </div>
            {showInactiveSchools && (
                <div className="tiles">
                    {getMappedInactiveSchools()}
                </div>
            )}
            <div className="reviewHeaders" style={{marginBottom: "60px", marginTop: "40px"}}>
                <h3 className="left" style={{marginTop: "50px"}}>Feedback</h3>
                <h3 className="right" style={{marginTop: "50px"}}><button to="/teacher/graded" className="link" onClick={() => navigate("/responded")}>View Feedback Responses {'>'}</button></h3>
            </div>
            <p>{message}</p>
            <div className="tiles">
                {getMappedFeedback()}
            </div>
            <div className="reviewHeaders" style={{marginBottom: "60px", marginTop: "40px"}}>
                <h3 className="left" style={{marginTop: "50px"}}>Metrics <button to="/metrics" className="link" onClick={() => navigate("/metrics")}>View Metrics {'>'}</button></h3>
            </div>
            
            <div className="reviewHeaders" style={{marginBottom: "60px", marginTop: "40px"}}>
                <h3 className="left" style={{marginTop: "50px"}}>User Management <button to="/user/management" className="link" onClick={() => navigate("/user/management")}>Manage Users {'>'}</button></h3>
            </div>
            
            {/* School Form Dialog */}
            <Dialog contentStyle={{ maxWidth: '480px' }} open={isMakingNewSchool} onRequestClose={closeSchoolForm}>
                <Provider store={store}>
                    <div style={{ padding: '20px' }}>
                        <h2 style={{ marginTop: '0', marginBottom: '10px', color: '#333' }}>
                            Add New School
                        </h2>
                        <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                            Create a new school in the system. You'll be able to add teachers and classes after the school is created.
                        </p>
                        <SchoolForm
                            onClose={closeSchoolForm}
                        />
                    </div>
                </Provider>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, { getSchools, getFeedback, setSchool, getSchoolTeachers, getSchoolClasses })(Admin);
